import { useQuery } from '@tanstack/react-query'
import { GlossariesApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { glossaryQueryKeys } from './queryKeys'

export const useQueryGlossaryJobsLatestStatus = (enabled: boolean) => {
  return useQuery({
    queryKey: glossaryQueryKeys.glossaryJobs.latestStatus(),
    queryFn: () =>
      baseClient
        .getApi(GlossariesApi)
        .getGlossaryJobsLatestStatus()
        .catch(handleHTTPError),
    enabled,
    retry: 0,
    staleTime: 0,
  })
}
